export default __webpack_public_path__ + "static/media/instagram.078887e3.png";